import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.placeOrder || initialState;

export const selectCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.companyDetails
);

export const selectPackages = createSelector(
  [selectDomain],
  (state) => state.packages
);

export const selectFetchingCatalog = createSelector(
  [selectDomain],
  (state) => state.fetchingCatalog
);

export const selectFetchingPackages = createSelector(
  [selectDomain],
  (state) => state.fetchingPackages
);

export const selectCategories = createSelector([selectDomain], (state) => {
  const catalog = state.catalog || [];
  const categories = [];
  catalog.forEach((item) => {
    const test = item.test || {};
    const commodityCategory = test.commodityCategory;
    const commodity = test.commodity;
    const index = categories.findIndex(
      (obj) => obj.name === commodityCategory.name
    );
    if (index === -1) {
      // push new category
      categories.push({
        name: commodityCategory.name,
        commodities: [commodity],
      });
    } else {
      const commodityIndex = categories[index].commodities.findIndex(
        (obj) => obj._id === commodity._id
      );
      if (commodityIndex === -1) {
        categories[index].commodities.push(commodity);
      }
    }
  });
  return categories;
});

/* export const selectCommodities = createSelector([selectDomain], (state) => {
  const catalog = state.catalog;
  const options = [];
  catalog.forEach((item) => {
    const test = item.test;
    const commodity = test.commodity;
    const commodityCategory = test.commodityCategory;

    const index = options.findIndex(
      (opt) => opt.label === commodityCategory.name
    );
    const commodityOption = { label: commodity.name, value: commodity._id };
    if (index === -1) {
      options.push({
        label: commodityCategory.name,
        options: [commodityOption],
      });
    } else {
      // check if commodity already exists in category
      const optIndex = options[index].options.findIndex(
        (cat) => cat.value === commodity._id
      );
      if (optIndex === -1) {
        options[index].options.push(commodityOption);
      }
    }
  });
  return options;
}); */

export const selectCatalog = createSelector(
  [selectDomain],
  (state) => state.catalog
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectTests = createSelector(
  [selectDomain],
  (state) => state.tests
);
